<template>
  <mf-card-container title="Análises geradas">
    <mf-loading class="pa-0" :boolean-loader="loading" loader-type="chart" />
    <div v-if="!loading" class="generated-report-analytics-card-container">
      <report-analytic-section
        v-if="hasRfvPermission"
        type="rfv"
        :recurrent-analytics="RfvRecurrentAnalytics"
        :not-recurrent-analytics="RfvNotRecurrentAnalytics"
        :limits="hubAnalyticsLimits.rfv"
      />
      <report-analytic-section
        v-if="hasDrePermission"
        type="dre"
        :recurrent-analytics="DreRecurrentAnalytics"
        :not-recurrent-analytics="DreNotRecurrentAnalytics"
        :limits="hubAnalyticsLimits.dre"
      />
    </div>
  </mf-card-container>
</template>

<script>
import ReportAnalyticSection from './ReportAnalyticSection.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'GeneratedReportAnalytics',
  components: { ReportAnalyticSection },
  computed: {
    ...mapGetters(['DREHubAnalyticsConfigurations', 'RFVHubAnalyticsConfigurations', 'hubAnalyticsLimits', 'loadingReportsList']),
    loading() {
      return this.loadingReportsList
    },
    hasRfvPermission() {
      return this.$getAllowedModules()['rfv'] && this.$permissions.havePagePermission('clientes/rfv')
    },
    hasDrePermission() {
      return this.$getAllowedModules()['offer_management'] && this.$permissions.havePagePermission('empresa/faturamento_incremental')
    },
    DreRecurrentAnalytics() {
      return this.DREHubAnalyticsConfigurations ? this.DREHubAnalyticsConfigurations.filter((report) => report.model === 'RECURRENT') : []
    },
    DreNotRecurrentAnalytics() {
      return this.DREHubAnalyticsConfigurations ? this.DREHubAnalyticsConfigurations.filter((report) => report.model === 'NOT_RECURRENT') : []
    },
    RfvRecurrentAnalytics() {
      return this.RFVHubAnalyticsConfigurations ? this.RFVHubAnalyticsConfigurations.filter((report) => report.model === 'RECURRENT') : []
    },
    RfvNotRecurrentAnalytics() {
      return this.RFVHubAnalyticsConfigurations ? this.RFVHubAnalyticsConfigurations.filter((report) => report.model === 'NOT_RECURRENT') : []
    },
  },
  async mounted() {
    await this.fetchData()
  },
  methods: {
    ...mapActions(['getHubAnalyticsConfigurations', 'getHubAnalyticsLimits', 'fetchHubData']),
    async fetchData() {
      try {
        await this.getHubAnalyticsLimits()
        await this.getHubAnalyticsConfigurations({ type: 'RFV' })
        await this.getHubAnalyticsConfigurations({ type: 'DRE' })
      } catch (error) {
        console.error(error)
        this.$snackbar({ message: 'Erro ao carregar análises.', snackbarColor: 'error' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.generated-report-analytics-card-container {
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 16px;
}
</style>
